<template>
    <div
        v-if="hasAutocompleteElements"
        :class="cssClasses">
        <span class="l-ss-c-autocomplete-help-text">{{ $t('autocomplete.help') }}</span>
        <span
            v-for="item in list"
            :key="item"
            class="l-ss-c-autocomplete-item"
            @click="() => handleSearch(item)">{{ item }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            search: {
                type: Object,
                required: false,
            },
        },
        data() {
            return {};
        },
        computed: {
            cssClasses() {
                return {
                    'l-ss-c-autocomplete': true,
                };
            },
            hasAutocompleteElements() {
                return this.search
                    && this.search.suggestions
                    && this.search.suggestions.length;
            },
            list() {
                return this.hasAutocompleteElements ? this.search.suggestions : [];
            },
        },
        methods: {
            handleSearch(value) {
                this.$emit('autocomplete-search', value);
            },
        },
    };
</script>
